/**
 * Load more – reveals the next batch of .js-loadMoreCard[hidden] items.
 * Scoped to the closest section so multiple blocks on one page don't interfere.
 */

var loadMoreReviews = {
    init: function () {
        document.querySelectorAll('.js-loadMoreBtn').forEach(function (btn) {
            btn.addEventListener('click', function () {
                var perPage  = parseInt( btn.dataset.perPage, 10 ) || 5;
                var section  = btn.closest('section');
                var scope    = section || document;

                var hidden = Array.from( scope.querySelectorAll('.js-loadMoreCard[hidden]') );
                hidden.sort( function (a, b) {
                    return parseInt( a.dataset.index, 10 ) - parseInt( b.dataset.index, 10 );
                });

                hidden.slice( 0, perPage ).forEach( function (card) {
                    card.removeAttribute('hidden');
                });

                if ( hidden.length <= perPage ) {
                    btn.closest('div').setAttribute('hidden', '');
                }
            });
        });
    },
};

export { loadMoreReviews };
